module.exports = __webpack_public_path__ + "static/media/datos electorales_b-01.daee7b4e.svg";